






























import { ScheduleType } from '@tt4b/ttam-enums';
import { defineComponent, computed, PropType } from '@vue/composition-api';

const name = 'ttam-schedule-date-duration-radio';

export default defineComponent({
  name,
  props: {
    value: {
      type: Number as PropType<ScheduleType>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    isShowHint: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const _scheduleType = computed({
      get: () => props.value,
      set: v => {
        console.log(v, 'scheduletype');
        emit('change', v);
        emit('input', v);
      },
    });

    const onMouseEnter = val => {
      emit('mouseenter', val);
    };

    const onMouseLeave = val => {
      emit('mouseleave', val);
    };

    return {
      name,
      ScheduleType,
      _scheduleType,
      onMouseEnter,
      onMouseLeave,
    };
  },
});
